import React from 'react';

import PropTypes from 'prop-types';

import { SubnavButton } from './SubnavButton';

import './css/Subnav.sass';

export const Subnav = ({ navItems }) => {
  const showUserCentrics = () => window.UC_UI?.showSecondLayer();

  return (
    <div className="subnav">
      <div className="footer-content">
        {navItems.map((navItem) => (
          <SubnavButton key={navItem.url} name={navItem.linkTitle} link={navItem.url} />
        ))}
        <SubnavButton
          name="Cookie Disclaimer"
          isCookieDisclaimerBtn
          clickCookieDisclaimer={showUserCentrics}
        />
      </div>
    </div>
  );
};

Subnav.propTypes = {
  navItems: PropTypes.array.isRequired,
};
